<div class="loader" *ngIf="isLoading"></div>
